import { initReadyState } from "./modules/init-ready-state.js";
import { initHeroImageBySeason } from "./modules/init-hero-image-by-season.js";
import { initHeaderInteractions } from "./modules/init-header-interactions.js";
import { initBookStripLayout } from "./modules/init-book-strip-layout.js";
import { initContentModals } from "./modules/init-content-modal.js";
import { initSubscribeModal } from "./modules/init-subscribe-modal.js";
import { initVideoModal } from "./modules/init-video-modal.js";
import { initCaseReader } from "./modules/init-case-reader.js";
import { initHistoryEraNav } from "./modules/init-history-era-nav.js";
import { initFloatingIntroTabs } from "./modules/init-floating-intro-tabs.js";

const pageInitializers = [
  (documentReference) => initContentModals(documentReference),
  (documentReference) => initSubscribeModal(documentReference),
  (documentReference) => initVideoModal(documentReference),
  (documentReference) => initReadyState(documentReference.querySelector(".page")),
  (documentReference) => initHeroImageBySeason(documentReference),
  (documentReference) => initHeaderInteractions(documentReference),
  (documentReference) => initBookStripLayout(documentReference),
  (documentReference) => initCaseReader(documentReference),
  (documentReference) => initHistoryEraNav(documentReference),
  (documentReference) => initFloatingIntroTabs(documentReference)
];

document.addEventListener("DOMContentLoaded", () => {
  pageInitializers.forEach((initialize) => initialize(document));
});
